import NAME from "./constants";

export const getLoading = store => store[NAME].isLoading || store[NAME].isLoadingConcepts;
export const getRows = store => store[NAME].rows;
export const getConcepts = store => store[NAME].concepts;
export const getTypes = store => store[NAME].types;
export const getSetTypes = store => store[NAME].setTypes;